document.addEventListener("DOMContentLoaded", function () {
    // 1) Optional discount notification (retained existing behavior)
    if (typeof window.activeDiscountCode !== "undefined" && window.activeDiscountCode) {
        const popup = document.createElement("div");
        popup.id = "discount-popup";
        popup.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            padding: 15px;
            background-color: #4CAF50;
            color: #ffffff;
            border-radius: 5px;
            box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
            z-index: 1000;
        `;
        popup.textContent = `Discount code "${window.activeDiscountCode}" applied! 🎉`;

        const closeButton = document.createElement("button");
        closeButton.style.cssText = `
            margin-left: 10px;
            padding: 5px 10px;
            background-color: #ffffff;
            color: #4CAF50;
            border: none;
            cursor: pointer;
        `;
        closeButton.textContent = "Close";
        closeButton.onclick = function () {
            popup.remove();
        };

        popup.appendChild(closeButton);
        document.body.appendChild(popup);
    }

    // 2) Cookie consent banner after 40s if not previously accepted
    const CONSENT_KEY = 'cookieConsentAccepted';
    const DELAY_MS = 40000; // 40 seconds

    function acceptedAlready() {
        try {
            return localStorage.getItem(CONSENT_KEY) === 'true';
        } catch (e) {
            return false;
        }
    }

    function anyModalOpen() {
        return (
            document.body.classList.contains('overflow-hidden') ||
            document.querySelector('.product-media-modal[open], .product-popup-modal[open], details-modal[open], .cart-drawer.is-open')
        );
    }

    function buildCookieBanner() {
        const bar = document.createElement('div');
        bar.id = 'cookie-consent-banner';
        bar.setAttribute('role', 'region');
        bar.setAttribute('aria-label', 'Cookie consent');
        bar.style.cssText = `
            position: fixed;
            left: 0; right: 0; bottom: 0;
            padding: 12px 16px;
            display: flex; align-items: center; gap: 12px; flex-wrap: wrap;
            background: rgba(0,0,0,0.9);
            color: #fff;
            z-index: 10000;
        `;

        const text = document.createElement('div');
        text.style.cssText = 'flex: 1 1 auto; min-width: 200px;';
        text.textContent = 'We use cookies to improve your experience. By using our site, you agree to our cookie policy.';

        const actions = document.createElement('div');
        actions.style.cssText = 'display:flex; align-items:center; gap:8px;';

        const acceptBtn = document.createElement('button');
        acceptBtn.type = 'button';
        acceptBtn.textContent = 'Accept';
        acceptBtn.style.cssText = `
            background:#ffffff; color:#000; border:0; border-radius:6px; padding:8px 12px; cursor:pointer;
        `;

        const declineBtn = document.createElement('button');
        declineBtn.type = 'button';
        declineBtn.textContent = 'Decline';
        declineBtn.style.cssText = `
            background:transparent; color:#fff; border:1px solid rgba(255,255,255,0.5); border-radius:6px; padding:8px 12px; cursor:pointer;
        `;

        acceptBtn.addEventListener('click', () => {
            try { localStorage.setItem(CONSENT_KEY, 'true'); } catch (e) {}
            // If Shopify privacy API is available, grant consent
            if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
                try { Shopify.customerPrivacy.setTrackingConsent(true); } catch (e) {}
            }
            bar.remove();
        });

        declineBtn.addEventListener('click', () => {
            try { localStorage.setItem(CONSENT_KEY, 'false'); } catch (e) {}
            if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
                try { Shopify.customerPrivacy.setTrackingConsent(false); } catch (e) {}
            }
            bar.remove();
        });

        actions.appendChild(acceptBtn);
        actions.appendChild(declineBtn);
        bar.appendChild(text);
        bar.appendChild(actions);
        return bar;
    }

    function showCookieBannerWithDeferral() {
        if (acceptedAlready()) return;
        // If another modal is open, wait and retry shortly to avoid stacking UI
        if (anyModalOpen()) {
            setTimeout(showCookieBannerWithDeferral, 2000);
            return;
        }
        // Only show once per page load
        if (!document.getElementById('cookie-consent-banner')) {
            document.body.appendChild(buildCookieBanner());
        }
    }

    // Schedule the banner 40s after DOM ready
    if (!acceptedAlready()) {
        setTimeout(showCookieBannerWithDeferral, DELAY_MS);
    }
});
